module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-3.aef0af56.jpeg";